import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import BasePath from './Pages/BasePath';
import LogIn from './Pages/LogIn';
import NotFoundPage from './Pages/NotFoundPage';
import InterpreterDashboard from './Pages/Interpreter/InterpreterDashboard';
import InterpreterHome from './Pages/Interpreter/InterpreterHome';
// import InterpreterUpcomingList from './Pages/Interpreter/InterpreterUpcomingList';
import AssignmentLists from './Components/Interpreter/AssignmentLists';
import AssignmentAcceptPage from './Pages/Interpreter/AssignmentAcceptPage';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import ProfileViewBottomNavigation from './Components/Interpreter/ProfileViewBottomNavigation';
import NotificationLists from './Pages/NotificationLists';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { SnackbarProvider } from 'notistack';
import RaiseInvoice from './Pages/Interpreter/RaiseInvoice';
import SplashScreenSuccess from './Components/SplashScreenSuccess';
import SplashScreenCustom from './Components/Interpreter/SplashScreenCustom';
import SupportPage from './Pages/Interpreter/AppSupport';
import AppSetting from './Pages/Interpreter/AppSetting';
import VacationSetting from './Components/Interpreter/VacationSetting';
import AboutPage from './Pages/Interpreter/AboutPage';
import RequestToUpdateProfile from './Pages/Interpreter/RequestToUpdateProfile';
import { AuthProvider } from './Context/AuthProvider';
import Home from './Pages/Home';

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Roboto",
    },
  },
});


function UrlRoutes() {
  const [PusherDashboardTrigger, PusherDashboardTriggerSet] = React.useState('');
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <ThemeProvider theme={theme} >
        <AuthProvider>
          <SnackbarProvider maxSnack={3} autoHideDuration={2000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/login' element={<LogIn />} />
              <Route path="Interpreter" element={<InterpreterHome PusherDashboardTriggerSet={PusherDashboardTriggerSet} PusherDashboardTrigger={PusherDashboardTrigger} />}>
                {/* <Route index element={<InterpreterDashboard />} /> */}
                <Route path="Dashboard" element={<InterpreterDashboard PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Notification_list" element={<NotificationLists PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="NewAssignment_list" element={<AssignmentLists assignStatus="inprogress" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Upcoming_list" element={<AssignmentLists assignStatus="upcoming" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Active_list" element={<AssignmentLists assignStatus="active" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Action_list" element={<AssignmentLists assignStatus="action" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Lapsed_list" element={<AssignmentLists assignStatus="lapsed" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Billed_list" element={<AssignmentLists assignStatus="billed" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="verification" element={<AssignmentLists assignStatus="verification" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Completed_list" element={<AssignmentLists assignStatus="completed" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Cancelled_list" element={<AssignmentLists assignStatus="cancelled" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Withdrawn_list" element={<AssignmentLists assignStatus="withdrawn" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Assignment_Acceptence/:assignid?/:pagestatus?" element={<AssignmentAcceptPage PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Assignment_DetailPage/:assignid?/:pagestatus?/:cancel_id?" element={<AssignmentAcceptPage PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="Profile_view" element={<ProfileViewBottomNavigation />} />
                <Route path="Update_profile" element={<RequestToUpdateProfile />} />
                <Route path="Raise_invoice" element={<RaiseInvoice />} />
                <Route path="Invoicehistory_list" element={<AssignmentLists assignStatus="invoicing" PusherDashboardTrigger={PusherDashboardTrigger} />} />
                <Route path="App_Setting" element={<AppSetting />} />
                <Route path="Vacation_Setting" element={<VacationSetting />} />
                <Route path="App_support" element={<SupportPage />} />
                <Route path="About_page" element={<AboutPage />} />
                <Route path="SplashScreen" element={<SplashScreenSuccess />} />
                <Route path="SplashScreen_Custom" element={<SplashScreenCustom />} />
              </Route>
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </SnackbarProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default UrlRoutes


